import { ContinuousInterviewingModalSource } from '__generated__/graphql';
import { ReduxAction } from 'types/redux.types';
import { InterviewInviteStep, interviewInviteActions } from './actions';

type InterviewInviteState = {
  visible: boolean;
  source: ContinuousInterviewingModalSource | null;
  step: InterviewInviteStep;
  calendlyOpen: boolean;
};

const initState: InterviewInviteState = {
  visible: false,
  source: null,
  step: InterviewInviteStep.Prompt,
  calendlyOpen: false,
};

export default function interviewInviteReducer(
  state: InterviewInviteState = initState,
  action: ReduxAction
): InterviewInviteState {
  switch (action.type) {
    case interviewInviteActions.SHOW_INTERVIEW_INVITE_MODAL:
      return {
        ...state,
        visible: true,
        source: action.payload.source,
        step: InterviewInviteStep.Prompt,
        calendlyOpen: false,
      };
    case interviewInviteActions.HIDE_INTERVIEW_INVITE_MODAL:
      // Only flip visibility off. Keeping `step`/`source`/`calendlyOpen` set
      // during the close animation prevents the body from flashing back to the
      // prompt while the panel is sliding away. The next SHOW resets these
      // fields, so a future open still starts fresh.
      return { ...state, visible: false };
    case interviewInviteActions.SET_INTERVIEW_INVITE_STEP:
      return { ...state, step: action.payload };
    case interviewInviteActions.SET_INTERVIEW_INVITE_CALENDLY_OPEN:
      return { ...state, calendlyOpen: action.payload };
    default:
      return state;
  }
}
